export const S = {
  card: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-card)',
    boxShadow: 'none',
    overflow: 'hidden',
  },
  head: {
    padding: '14px 16px',
    borderBottom: '1px solid var(--border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
    background: 'var(--bg-subtle)',
  },
  title: { margin: 0, fontSize: 15, fontWeight: 950, color: 'var(--text)' },
  sub: { marginTop: 3, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.45 },
  controls: { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'end' },
  field: { display: 'flex', flexDirection: 'column', gap: 4 },
  label: { fontSize: 11, fontWeight: 900, color: 'var(--text-muted)' },
  input: {
    height: 34,
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 10px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    fontSize: 13,
    outline: 'none',
    boxSizing: 'border-box',
  },
  btn: {
    height: 34,
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 12px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontSize: 12,
    fontWeight: 900,
    cursor: 'pointer',
  },
  body: { padding: 14, display: 'flex', flexDirection: 'column', gap: 12 },
  summaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(130px,1fr))', gap: 8 },
  metric: {
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '9px 10px',
    background: 'var(--bg-subtle)',
    minHeight: 56,
  },
  metricLabel: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 850 },
  metricValue: { marginTop: 4, fontSize: 16, color: 'var(--text)', fontWeight: 950 },
  formula: {
    border: '1px solid rgba(37,99,235,0.22)',
    borderRadius: 10,
    padding: '9px 10px',
    background: 'rgba(37,99,235,0.06)',
    color: 'var(--text-sub)',
    fontSize: 12,
    lineHeight: 1.55,
  },
  error: {
    border: '1px solid rgba(220,38,38,0.22)',
    borderRadius: 10,
    padding: '9px 10px',
    background: 'rgba(220,38,38,0.07)',
    color: '#dc2626',
    fontSize: 12,
    fontWeight: 800,
  },
  workspace: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%, 340px),1fr))',
    gap: 12,
    alignItems: 'start',
  },
  calculationWorkspace: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 420px), 1fr))',
    gap: 12,
    alignItems: 'start',
  },
  listPanel: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-subtle)',
    overflow: 'hidden',
  },
  listHead: {
    padding: '10px 12px',
    borderBottom: '1px solid var(--border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  },
  listTitle: { fontSize: 13, fontWeight: 950, color: 'var(--text)' },
  listSub: { marginTop: 2, fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.35 },
  listBody: { padding: 8, display: 'flex', flexDirection: 'column', gap: 6 },
  group: { padding: 10, borderBottom: '1px solid var(--border)' },
  groupTitle: { fontSize: 12, fontWeight: 950, color: 'var(--text-sub)', marginBottom: 6 },
  personBtn: (active) => ({
    width: '100%',
    border: active ? '2px solid #2563eb' : '1px solid var(--border)',
    borderRadius: 10,
    background: active ? 'rgba(37,99,235,0.08)' : 'var(--bg-card)',
    color: 'var(--text)',
    padding: 10,
    marginBottom: 0,
    cursor: 'pointer',
    textAlign: 'left',
    boxSizing: 'border-box',
  }),
  personTop: { display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' },
  personName: { fontSize: 13, fontWeight: 950, color: 'var(--text)' },
  personMeta: { marginTop: 3, fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.4 },
  personCharge: { fontSize: 13, fontWeight: 950, color: '#2563eb', whiteSpace: 'nowrap' },
  personMetrics: { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 5, marginTop: 8 },
  personActions: { display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 8 },
  miniActionBtn: {
    height: 26,
    border: '1px solid var(--border)',
    borderRadius: 7,
    padding: '0 9px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontSize: 10,
    fontWeight: 950,
    cursor: 'pointer',
  },
  personMetric: {
    borderRadius: 8,
    padding: '5px 6px',
    background: 'var(--bg-subtle)',
    minWidth: 0,
  },
  personMetricLabel: { fontSize: 9, color: 'var(--text-muted)', fontWeight: 900 },
  personMetricValue: { marginTop: 2, fontSize: 11, color: 'var(--text)', fontWeight: 950, whiteSpace: 'nowrap' },
  pill: (tone = 'default') => ({
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    padding: '2px 7px',
    background: tone === 'warn'
      ? 'rgba(245,158,11,0.14)'
      : tone === 'blue'
        ? 'rgba(37,99,235,0.12)'
        : tone === 'ok'
          ? 'rgba(22,163,74,0.12)'
          : tone === 'danger'
            ? 'rgba(220,38,38,0.10)'
            : 'rgba(100,116,139,0.12)',
    color: tone === 'warn'
      ? '#b45309'
      : tone === 'blue'
        ? '#2563eb'
        : tone === 'ok'
          ? '#15803d'
          : tone === 'danger'
            ? '#dc2626'
            : 'var(--text-muted)',
    fontSize: 10,
    fontWeight: 950,
    marginRight: 4,
    marginTop: 6,
  }),
  detailPanel: { display: 'flex', flexDirection: 'column', gap: 12, minWidth: 0 },
  detailHeader: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-card)',
    padding: 14,
    minWidth: 0,
  },
  selectedTitle: { fontSize: 18, fontWeight: 950, color: 'var(--text)' },
  detailHeaderTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 10,
    flexWrap: 'wrap',
  },
  detailHeaderInfo: { minWidth: 0, flex: '1 1 220px' },
  detailActions: {
    display: 'flex',
    gap: 6,
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
  detailActionBtn: (active) => ({
    height: 30,
    border: active ? '1px solid #2563eb' : '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 10px',
    background: active ? '#2563eb' : 'var(--bg-card)',
    color: active ? '#fff' : 'var(--text-sub)',
    fontSize: 11,
    fontWeight: 950,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  }),
  detailSub: { marginTop: 4, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.45 },
  calcGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(125px,1fr))', gap: 8, marginTop: 12 },
  detailGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 10 },
  detailBox: {
    border: '1px solid var(--border)',
    borderRadius: 10,
    background: 'var(--bg-card)',
    padding: 10,
    minWidth: 0,
  },
  detailTitle: { fontSize: 12, fontWeight: 950, color: 'var(--text)', marginBottom: 7 },
  line: { display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 12, color: 'var(--text-sub)', padding: '3px 0' },
  muted: { color: 'var(--text-muted)', fontSize: 12, lineHeight: 1.45 },
  mini: { fontSize: 11, color: 'var(--text-muted)', marginTop: 3, lineHeight: 1.4 },
  warning: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    padding: '2px 7px',
    background: 'rgba(245,158,11,0.14)',
    color: '#b45309',
    fontSize: 10,
    fontWeight: 950,
    marginRight: 4,
    marginTop: 8,
  },
  tableWrap: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-card)',
    overflowX: 'auto',
  },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: 880 },
  th: {
    padding: '9px 10px',
    borderBottom: '1px solid var(--border)',
    background: 'var(--bg-subtle)',
    color: 'var(--text-muted)',
    fontSize: 11,
    fontWeight: 950,
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '8px 10px',
    borderBottom: '1px solid var(--border)',
    color: 'var(--text-sub)',
    fontSize: 12,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  tr: (active) => ({
    background: active ? 'rgba(37,99,235,0.08)' : 'transparent',
    cursor: 'pointer',
  }),
  moneyCell: { color: '#2563eb', fontWeight: 950, textAlign: 'right' },
  numCell: { color: 'var(--text)', fontWeight: 900, textAlign: 'right' },
  detailShell: {
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-subtle)',
    padding: 10,
  },
  compactRule: {
    border: '1px solid var(--border)',
    borderRadius: 10,
    background: 'var(--bg-card)',
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    flexWrap: 'wrap',
  },
  compactRuleMain: { minWidth: 0 },
  compactRuleTitle: { fontSize: 12, fontWeight: 950, color: 'var(--text)' },
  compactRuleText: { marginTop: 3, fontSize: 11, color: 'var(--text-muted)', lineHeight: 1.35 },
};
